import { takeLatest, put, call, all, fork } from "redux-saga/effects";
import { openCase, createCase } from "services";
import { 
    updateOpenCase,
    createdCase,
    failedCreateCase,
    createdBulkAdhocCase,
    failedCreateBulkAdhocCase,
    createdBulkPayProCase,
    failedCreateBulkPayProCase
} from "store/actions/case-create-actions";
import { message } from "antd";
import { STATE_STATUS } from "constants/state-status";
import { CASE_CREATE_ACTIONS } from "constants";
import { CaseService } from "services/index";
import { resetStageCase } from "store/actions/index";
import { history } from "router";

function* openCases({ payload: { cases } }) {
    let updatedCases = cases;

    try {
        const values = yield all(
            cases
                .map((_, caseID) => call(openCase, caseID, _.form))
                .toList()
                .toArray()
        );
    
        values.map(({ caseID, data, error }) => {
            if (!error) {
                updatedCases = updatedCases.mergeIn([caseID], {
                    status: STATE_STATUS.CREATED,
                    case_create_id: data.id,
                    case_create_company_id: data.company.id
                });
                return;
            }
            message.error("Case creation failed");
            updatedCases = updatedCases.mergeIn([caseID], {
                status: STATE_STATUS.CREATE_FAILED
            });
        });
    
        const caseTaskResponse = yield all(
            values.map(({ data }) => call(CaseService.getActiveCaseTask, data.id))
        );
        yield all(
            caseTaskResponse.map(({ data, error }) =>
                error ? null : put(resetStageCase("INBOX", data.this_stage))
            )
        );
    } catch(e) {
        message.error("Case creation failed");
    }
    yield put(updateOpenCase(updatedCases));
}

function* createNewCase({ payload: { caseEntry, contact_detail }}) {
    try {
        const { error, data } = yield call(createCase, caseEntry.form, contact_detail);
        if(!error) {
            yield put(createdCase(caseEntry.set("status", STATE_STATUS.CREATED)));
            history.replace(`/app/inbox/${data.id}/case_details`);
        } else {
            yield put(failedCreateCase(caseEntry.set("status", STATE_STATUS.CREATE_FAILED), contact_detail, error));
        }
    } catch(error) {
        message.destroy();
        if(error && error.non_field_errors && error.non_field_errors.length) {
            error.non_field_errors.map(_ => {
                message.error(_);
            });
        }else{
            error && error.map(el=>message.error(el));
        }
    }
    yield put(failedCreateCase(caseEntry.set("status", STATE_STATUS.CREATE_FAILED), contact_detail));
}

function* createBulkAdhocCase({ payload: { caseData } }) {
    message.loading("Request in progress... ", 0);
    try {
        const { error, data } = yield call(
            CaseService.createBulkAdhocCases,
            caseData
        );
        message.destroy();
        if(!error) {
            message.success("Adhoc Cases request created successfully");
            yield put(createdBulkAdhocCase(caseData, data));
        } else {
            message.error("Failed to create Adhoc Cases request");
            yield put(failedCreateBulkAdhocCase(caseData, error));
        }
    } catch(error) {
        message.destroy();
        message.error("Failed to create Adhoc Cases request");
        yield put(failedCreateBulkAdhocCase(caseData, error));
    }
}

function* createBulkPayProCase({ payload: { caseData } }) {
    message.loading("Request in progress... ", 0);
    try {
        const { error, data } = yield call(
            CaseService.createBulkPayProCases,
            caseData
        );
        message.destroy();
        if(!error) {
            message.success("Payment Program request created successfully");
            yield put(createdBulkPayProCase(caseData, data));
        } else {
            message.error("Failed to create Payment Program request");
            yield put(failedCreateBulkPayProCase(caseData, error));
        }
    } catch(error) {
        message.destroy();
        message.error("Failed to create Payment Program request");
        yield put(failedCreateBulkPayProCase(caseData, error));
    }
}


export default fork(function*() {
    yield takeLatest(CASE_CREATE_ACTIONS.OPEN_CASE, openCases);
    yield takeLatest(CASE_CREATE_ACTIONS.CREATE_CASE, createNewCase);
    yield takeLatest(CASE_CREATE_ACTIONS.BULK_ADHOC_CASE_CREATE, createBulkAdhocCase);
    yield takeLatest(CASE_CREATE_ACTIONS.BULK_PAYPRO_CASE_CREATE, createBulkPayProCase);
});
